<form nz-form name="demo">



  <!-- MULTISEARCH PROTO -->
  <div class="flexie-auto-grid">
    <div></div>
    <div>
      <h3>Multi-Search</h3>
      <div class="multisearch">
        <div class="multisearch-grid">

          <!-- Dropdown for selecting Filter -->
          <nz-select nzShowSearch [ngModel]="'Email'">
            <nz-option [nzLabel]="'Email'" [nzValue]="'Email'"></nz-option>
            <nz-option [nzLabel]="'User'" [nzValue]="'User'"></nz-option>
          </nz-select>

          <!-- Input filed (resets and changes based on dropdown selection) -->
          <input type="email" nz-input placeholder="Email" />

          <!-- Button Add row (FIRST ROW WILL HAVE THIS) -->
          <button nz-button nzType="dashed">
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>

        </div>

        <!-- DEMO REPEAT OF ABOVE -- Can Ignore -->
        <div class="multisearch-grid">
          <nz-select nzShowSearch [ngModel]="'Role'">
            <nz-option [nzLabel]="'Email'" [nzValue]="'Email'"></nz-option>
            <nz-option [nzLabel]="'Role'" [nzValue]="'Role'"></nz-option>
          </nz-select>
          <!-- Input -->
          <nz-select nzShowSearch style="width: auto" nzAllowClear nzPlaceHolder="Choose">
            <nz-option nzValue="Agent" nzLabel="Agent"></nz-option>
            <nz-option nzValue="Group" nzLabel="Group"></nz-option>
          </nz-select>
          <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this row?" nzOkText="Remove"
            nzCancelText="Cancel">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </div>

        <!-- Add New Row -- >
                <div class="multisearch-add-row multisearch-grid">
                    <div><small class="p-l-10">Add new filter</small></div>
                    <div>&nbsp;</div>
                    <button nz-button nzType="dashed">
                        <i nz-icon nzType="plus"  nzTheme="outline"></i>
                    </button>
                </div>
                <!-- -->

      </div>
    </div>

    <div>
      <h3>Search (ALT. DESIGN)</h3>
      <nz-select nzShowSearch class="d-b w-100-pc" nzMode="multiple" [(ngModel)]="selectedValue"
        (ngModelChange)="loadFaker()" nzAllowClear nzPlaceHolder="Choose">
        <nz-option-group nzLabel="Product">
          <nz-option nzValue="1" nzLabel="Product: StandardLife"></nz-option>
          <nz-option nzValue="2" nzLabel="Product: Life+"></nz-option>
          <nz-option nzValue="3" nzLabel="Product: MediPRO"></nz-option>
        </nz-option-group>
        <nz-option-group nzLabel="Task Status">
          <nz-option nzValue="56" nzLabel="Task: Data Entry"></nz-option>
          <nz-option nzValue="57" nzLabel="Task: Intimation Completed"></nz-option>
        </nz-option-group>
      </nz-select>

      <div class="options-grid" *ngIf="optionTEMP">
        <nz-input-group nzCompact>
          <nz-select nzShowSearch [ngModel]="'Between'">
            <nz-option [nzLabel]="'Complexity'" [nzValue]="'Between'"></nz-option>
            <nz-option [nzLabel]="'Priority'" [nzValue]="'Except'"></nz-option>
          </nz-select>
          <input type="text" nz-input placeholder="From" style="width:100px; text-align: center;" />
          <input type="text" disabled nz-input placeholder="~"
            style="width: 30px; border-left: 0; pointer-events: none; background-color: rgb(255, 255, 255);" />
          <input type="text" nz-input placeholder="to" style="width: 100px; text-align: center; border-left: 0" />
        </nz-input-group>
        <button nz-button (click)="optionTEMP=!optionTEMP">Remove</button>
      </div>

      <div class="options-grid" *ngIf="optionTEMP">
        <div></div>
        <button nz-button (click)="optionTEMP=!optionTEMP">Add</button>
      </div>

    </div>
  </div>



  <div class="card-container----m-b-20">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom':'53px' }"
      [nzMaskClosable]="false" [nzWidth]="640" [nzVisible]="visibleDrawer1" nzTitle="Person"
      (nzOnClose)="closeDrawer1()">
      <form nz-form>
        <!-- xxxxxx -->

        <div class="form-secondary-fields">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">First Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="First Name" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Last Name" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Category</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio nzValue="A">Class XS</label>
                <label nz-radio nzValue="B">Class A</label>
                <label nz-radio nzValue="C">Class D</label>
                <label nz-radio nzValue="D">Class XE</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Notes</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <textarea nz-input placeholder="Additional notes ..." ngModel nzAutosize></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>


        <div>
          <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
            <ng-template #item let-item>
              <nz-list-item [nzActions]="[editAction,moreAction]">
                <nz-skeleton [nzActive]="true" [nzLoading]="false">
                  <ng-template #editAction><a (click)="edit(item)">edit</a></ng-template>
                  <ng-template #moreAction><a (click)="view(item)">view</a></ng-template>
                  <nz-list-item-meta [nzTitle]="'Home Address'"
                    nzDescription="B 808, Palazzo, Water Edge Society, Baner, Pune">
                  </nz-list-item-meta>
                </nz-skeleton>
              </nz-list-item>
            </ng-template>
          </nz-list>
        </div>

        <button nz-button nzType="primary" (click)="openDrawer2()">Add Address</button>

        <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom':'53px' }"
          [nzMaskClosable]="false" [nzWidth]="600" [nzVisible]="visibleDrawer2" nzTitle="Address"
          (nzOnClose)="closeDrawer2()">
          <form nz-form>
            <div class="form-secondary-fields">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Address Line 1</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="Address Line 1" [(ngModel)]="value" name="input-basic" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Address Line 2</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="Address Line 2" [(ngModel)]="value" name="input-basic" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Region</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                    <label nz-radio nzValue="A">Region A</label>
                    <label nz-radio nzValue="B">Region B</label>
                    <label nz-radio nzValue="C">Region C</label>
                    <label nz-radio nzValue="D">Region D</label>
                  </nz-radio-group>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Notes </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <textarea nz-input placeholder="Autosize height based on content lines" ngModel nzAutosize></textarea>
                </nz-form-control>
              </nz-form-item>
            </div>
          </form>
          <div class="drawer-action-footer">
            <button type="button" (click)="closeDrawer2()" class="ant-btn"
              style="margin-right: 8px;"><span>Cancel</span></button>
            <button type="button" (click)="closeDrawer2()" class="ant-btn ant-btn-primary"><span>Add
                Address</span></button>
          </div>
        </nz-drawer>



      </form>
      <div class="drawer-action-footer">
        <button type="button" (click)="closeDrawer1()" class="ant-btn"
          style="margin-right: 8px;"><span>Cancel</span></button>
        <button type="button" (click)="closeDrawer1()" class="ant-btn ant-btn-primary"><span>Submit</span></button>
      </div>
    </nz-drawer>
  </div>

  <div class="card-container m-b-40">

    <div class="card-summary-title card-summary-ribbon">

      <h3 class="prominent">
        <i nz-icon nzType="file-protect" nzTheme="outline"></i> &nbsp;
        Life Proposal
        <nz-tag [nzColor]="'#667788'">Pending</nz-tag>
      </h3>

      <div class="card-summary-ribbon-grid">
        <div>
          <div class="flexie-auto-grid p-b-20">
            <div><strong>Proposal Number:</strong> P0030547</div>
            <div><strong>Stage:</strong> Data Entry Pending
              <button nz-button [nzSize]="'small'" nzType="primary" nzGhost nz-popover nzPopoverTitle="Tasks Timeline"
                [nzPopoverContent]="tasksTimelineTemplate" nzTooltipPlacement="bottomRight">Track Tasks</button>
            </div>
            <div><strong>Current Status:</strong> Draft</div>
          </div>
          <div class="flexie-auto-grid p-b-20">

            <div><strong>Total Sum Insured :</strong> IDR 550.449.000,00</div>
            <div><strong>Total Premium :</strong> IDR 1.818.959,25</div>
            <div><strong>UW Decision: </strong> Pending</div>
          </div>
        </div>
        <div>
          <a href="javascript:void(0);" (click)="openDrawer1()">
            <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon" nz-tooltip nzTooltipTitle="My Notes"
              nzTooltipPlacement="center"></i>
            <small class="d-b f-s-09r">Notes</small>
          </a>
        </div>
      </div>

      <ng-template #tasksTimelineTemplate>
        <nz-timeline class="p-20">
          <nz-timeline-item [nzDot]="timeWaitTemplate">
            Data Entry
            <small class="d-b">
              PAPER ENTRY assigned to Jane Doe
            </small>
          </nz-timeline-item>
          <nz-timeline-item nzColor="green">
            Policy initialisation
            <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
          </nz-timeline-item>
        </nz-timeline>
      </ng-template>

      <ng-template #timeWaitTemplate>
        <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
      </ng-template>

      <div>
        <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
          <nz-progress nz-tooltip [nzPercent]="60" [nzSuccessPercent]="30" nzStatus="active"></nz-progress>
        </nz-tooltip>
      </div>

    </div>


    <ng-template #avatarTemplate>
      <nz-avatar style="color:#f56a00; background-color:#fde3cf;"
        [nzSrc]="'https://randomuser.me/api/portraits/men/40.jpg'" nzSize="small" nzIcon="anticon anticon-user">
      </nz-avatar>
    </ng-template>
    <div class="flexie-auto-grid">
      <div>
        <nz-card>
          <nz-card-meta [nzAvatar]="avatarTemplate" nzTitle="Primary Insured" nzDescription="Mr. Jeremiah Torres">
          </nz-card-meta>
        </nz-card>
      </div>
      <div>
        <nz-card>
          <nz-card-meta [nzAvatar]="avatarTemplate" nzTitle="Primary Insured" nzDescription="Mr. Jeremiah Torres">
          </nz-card-meta>
        </nz-card>
      </div>
      <div></div>
      <div></div>
    </div>


    <div class="card-summary-title flex flex-horiz-space-bw">
      <h3 class="heading"><i nz-icon nzType="user"></i> Products</h3>
      <nz-button-group>
        <!-- <nz-dropdown-button  class="b-0">
                    Edit Products
                    <ul nz-menu>
                        <li nz-menu-item (click)="cardCollapsed=!cardCollapsed;">Edit</li>
                        <li nz-menu-item>View</li>
                        <li nz-submenu>
                            <span title>More ...</span>
                            <ul>
                                <li nz-menu-item>Reset Section</li>
                            </ul>
                        </li>
                    </ul>
                </nz-dropdown-button> -->
      </nz-button-group>
    </div>

    <div class="card-summary" *ngIf="!cardCollapsed">
      <div class="card-summary-content">
        <div class="card-summary-data-grid">
          <div class="card-summary-data">
            <b>Name:</b>
            <!--<nz-avatar nzIcon="user" nzSrc="https://randomuser.me/api/portraits/women/17.jpg"></nz-avatar>--> Kiran
            Beri
          </div>
          <div class="card-summary-data">
            <b>Make:</b> BMW
          </div>
          <div class="card-summary-data">
            <b>Model:</b> Roadster
          </div>
          <div class="card-summary-data">
            <b>Country:</b> India
          </div>
          <div class="card-summary-data">
            <b>Summary:</b> Yes
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="cardCollapsed">
      <div>
        <!-- Forms , rows -->
        <div class="flexie-auto-grid">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [nzButtonStyle]="'solid'" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio-button nzValue="A">Search Agent</label>
                <label nz-radio-button nzValue="B">Add new Agent</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
          <div></div>
        </div>


        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
        </div>

      </div>
      <div class="card-summary-data-footer">
        <div>
          <button nz-button (click)="cardCollapsed=!cardCollapsed">Cancel</button>
        </div>
        <div>
          <button nz-button class="b-0 m-r-10" (click)="cardCollapsed=!cardCollapsed">Cancel</button>
          <button nz-button [nzType]="'primary'" (click)="cardCollapsed=!cardCollapsed">Save</button>
        </div>
      </div>
    </div>

  </div>

  <!-- Secondary form -->
  <div class="flexie-auto-grid m-t-b-60">

    <div class="flex-self-vert-start">
      <div *ngIf="!savedAdd">
        <div class="zero-ui">
          <i nz-icon nzType="schedule" nzTheme="outline"></i>
          <h2>Add Address</h2>
          <p>You need to atleast one address to continue</p>
        </div>
      </div>
      <div *ngIf="savedAdd">
        <h3> Addresses </h3>
        <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
          <ng-template #item let-item>
            <nz-list-item [nzActions]="[editAction,moreAction]">
              <nz-skeleton [nzActive]="true" [nzLoading]="false">
                <ng-template #editAction><a (click)="edit(item)">edit</a></ng-template>
                <ng-template #moreAction><a (click)="view(item)">view</a></ng-template>
                <nz-list-item-meta [nzTitle]="'Home Address'"
                  nzDescription="B 808, Palazzo, Water Edge Society, Baner, Pune">
                </nz-list-item-meta>
              </nz-skeleton>
            </nz-list-item>
          </ng-template>
        </nz-list>
      </div>
    </div>

    <div>
      <div class="form-secondary">

        <h3 class="form-secondary-heading">+ Add Address</h3>

        <div class="form-secondary-fields p-l-r-20 p-t-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">First Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Radio</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio nzValue="A">Monday</label>
                <label nz-radio nzValue="B">Tuesday</label>
                <label nz-radio nzValue="C">Wednesday</label>
                <label nz-radio nzValue="D">Thursday</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Address</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <textarea nz-input placeholder="Autosize height based on content lines" ngModel nzAutosize></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="footer-actions-bar">
          <div>
            <!-- Left -->
          </div>
          <div>
            <!-- Right -->
            <button nz-button class="b-0 m-r-10">Clear</button>
            <button nz-button [nzType]="'primary'" (click)="savedAdd=!savedAdd">Add</button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="flexie-auto-grid m-t-30">

    <div>

      <div class="zero-ui">
        <div class="flexie-auto-grid">
          <div class="zero-ui-clickable">
            <i nz-icon nzType="schedule" nzTheme="outline"></i>
            <h2>Add Address</h2>
            <p>You need to at-least one address</p>
          </div>
          <div class="zero-ui-clickable">
            <i nz-icon nzType="team" nzTheme="outline"></i>
            <h2>Add People</h2>
            <p>You could alternatively add people too</p>
          </div>
        </div>
      </div>

    </div>

    <div>
      <div class="zero-ui zero-ui-clickable" (click)="openDrawer1()">
        <i nz-icon nzType="schedule" nzTheme="outline"></i>
        <h2>Add Address</h2>
        <p>You need to atleast one address to continue</p>
      </div>
    </div>


  </div>

  <div id="form-controls">

    <h1 class="kitchensink">Form Controls </h1>

    <h1>Cascading Inputs</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Make / Model / Variant</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-cascader name="cascader" [nzOptions]="nzOptions" [(ngModel)]="values" (ngModelChange)="onChanges($event)">
        </nz-cascader>
      </nz-form-control>
    </nz-form-item>


    <h1>Standard Form Controls</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Radio</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
          <label nz-radio nzValue="A">Monday</label>
          <label nz-radio nzValue="B">Tuesday</label>
          <label nz-radio nzValue="C">Wednesday</label>
          <label nz-radio nzValue="D">Thursday</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Radio Block</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-radio-group nzName="radiogroup" [nzButtonStyle]="'solid'" [(ngModel)]="radioValue" name="radiogroup">
          <label nz-radio-button nzValue="A">Monday</label>
          <label nz-radio-button nzValue="B">Tuesday</label>
          <label nz-radio-button nzValue="C">Wednesday</label>
          <label nz-radio-button nzValue="D">Thursday</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-label [nzSpan]="5">Generic Date</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-date-picker name="date" [(ngModel)]="date" (ngModelChange)="onChange($event)"
          [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Select Date Range</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-range-picker name="daterange" [(ngModel)]="dateRange" (ngModelChange)="onChange($event)" nzShowTime>
        </nz-range-picker>
      </nz-form-control>
    </nz-form-item>


    <h1>Transfer Component</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Select your desired addons</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-transfer [nzDataSource]="list_transfer" [nzTitles]="['Available', 'Selected']"
          (nzSelectChange)="selectTransferList($event)" (nzChange)="changeTransferList($event)">
        </nz-transfer>
        <!--<div style="margin-top: 8px;">
                    <nz-switch [(ngModel)]="disabledTransfer" nzCheckedChildren="disabled" nzUnCheckedChildren="disabled"></nz-switch>
                </div>-->
      </nz-form-control>
    </nz-form-item>


    <h1>Select All Sample</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">
        Choose your options
      </nz-form-label>
      <nz-form-control [nzSpan]="12">
        <label nz-checkbox name="checkall" [(ngModel)]="allChecked" (ngModelChange)="updateAllChecked()"
          [nzIndeterminate]="indeterminate">
          Check all
        </label>
        <br>
        <nz-checkbox-group name="checkboxes" [(ngModel)]="checkOptionsOne" (ngModelChange)="updateSingleChecked()">
        </nz-checkbox-group>
      </nz-form-control>
    </nz-form-item>


    <h1>Sliders</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Simple Slider</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-row>
          <nz-col nzSpan="12">
            <nz-slider [nzMin]="1" [nzMax]="20" [(ngModel)]="slider_value" name="slider"></nz-slider>
          </nz-col>
          <div nz-col nzSpan="4">
            <nz-input-number [nzMin]="1" [nzMax]="20" [ngStyle]="{ 'marginLeft': '16px' }" [(ngModel)]="slider_value"
              name="slider"></nz-input-number>
          </div>
        </nz-row>
      </nz-form-control>
    </nz-form-item>

    <h1>Select</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Select a user</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-select nzShowSearch style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
          <nz-option nzValue="1" nzLabel="Agent One"></nz-option>
          <nz-option nzValue="0" nzLabel="Agent Zero"></nz-option>
          <nz-option nzValue="disabled" nzLabel="Disabled Agent X" nzDisabled></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Multi-Select</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-select nzShowSearch [nzMaxMultipleCount]="3" style="width: 100%" nzMode="multiple"
          nzPlaceHolder="Please select">
          <nz-option [nzLabel]="'Addon 1'" [nzValue]="'a'"></nz-option>
          <nz-option [nzLabel]="'Addon 3'" [nzValue]="'b'"></nz-option>
          <nz-option [nzLabel]="'Addon XS'" [nzValue]="'c'"></nz-option>
          <nz-option [nzLabel]="'Addon 7'" [nzValue]="'d'"></nz-option>
          <nz-option [nzLabel]="'Addon 5A'" [nzValue]="'e'"></nz-option>
        </nz-select>
        <small>Select upto 3 items</small>
      </nz-form-control>
    </nz-form-item>


    <h1>Date and Time </h1>
    <nz-form-item>
      <nz-form-label [nzSpan]="5" nzRequired>Date</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-date-picker [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5" nzRequired>Date and Time</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>


    <h1>Input Types and styles</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Username</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-input-group [nzSuffix]="suffixTemplateInput" [nzPrefix]="prefixTemplateInput">
          <input type="text" nz-input placeholder="Enter your username" [(ngModel)]="username" name="username">
        </nz-input-group>
        <ng-template #prefixTemplateInput><i nz-icon nzType="user"></i></ng-template>
        <ng-template #suffixTemplateInput><i nz-icon nzType="close-circle" (click)="username=null" *ngIf="username"></i>
        </ng-template>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-label [nzSpan]="5">Input Mixins</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-input-group>
          <input type="text" nz-input [ngModel]="'NOTE: Setup Activity on '" name="input-combo" style="width:50%;">
          <nz-date-picker [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-label [nzSpan]="5">Multiple Inputs</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-input-group nzCompact>
          <nz-select nzShowSearch [ngModel]="'Between'" name="input-range">
            <nz-option [nzLabel]="'Between'" [nzValue]="'Between'"></nz-option>
            <nz-option [nzLabel]="'Except'" [nzValue]="'Except'"></nz-option>
          </nz-select>
          <input type="text" nz-input placeholder="Minimum" style="width:100px; text-align: center;">
          <input type="text" disabled nz-input placeholder="~"
            style="width: 30px; border-left: 0px; pointer-events: none; background-color: rgb(255, 255, 255);">
          <input type="text" nz-input placeholder="Maximum" style="width: 100px; text-align: center; border-left: 0px;">
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Multiple Inputs</nz-form-label>
      <nz-form-control [nzSpan]="15">
        <nz-input-group nzCompact>
          <nz-select nzShowSearch [ngModel]="'Home'" name="input-multi" style="width: 30%;">
            <nz-option [nzLabel]="'New'" [nzValue]="'New'"></nz-option>
            <nz-option [nzLabel]="'Used'" [nzValue]="'Used'"></nz-option>
          </nz-select>
          <!-- Car model cascader -->
          <nz-cascader [nzOptions]="options" style="width: 70%;"></nz-cascader>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>


    <h1>Switches</h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Disabled when processing</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-switch name="input-switch-loading" [(ngModel)]="switchValue" [nzControl]="true" (click)="clickSwitch()"
          [nzLoading]="loading"></nz-switch>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Yes / No</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-switch [ngModel]="switchValue" name="input-switch"></nz-switch>
        Default
        <br>
        <nz-switch nzSize="small" [ngModel]="switchValue" name="input-switch"></nz-switch>
        Small
      </nz-form-control>
    </nz-form-item>



    <h1>Form: Successes and Errors </h1>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Validating</nz-form-label>
      <nz-form-control [nzSpan]="12" nzValidateStatus="validating" nzHasFeedback>
        <input nz-input name="validating">
        <!-- <nz-form-explain>Validation in progress. See loading indicator on right.</nz-form-explain> -->
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Fail</nz-form-label>
      <nz-form-control nzValidateStatus="error" [nzSpan]="12">
        <input nz-input name="errorValid">
        <!-- <nz-form-explain>Should be combination of numbers & alphabets</nz-form-explain> -->
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Warning</nz-form-label>
      <nz-form-control nzValidateStatus="warning" [nzSpan]="12">
        <input nz-input name="warningValid">
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="5">Warning</nz-form-label>
      <nz-form-control [nzSpan]="12" nzValidateStatus="warning" nzHasFeedback>
        <nz-time-picker name="time-picker-warning" style="width: 100%" [nzFormat]="'HH:mm'"></nz-time-picker>
        <!-- <nz-form-explain>Warning on another form component</nz-form-explain> -->
      </nz-form-control>
    </nz-form-item>


    <h1>Tree Data Structure</h1>
    <nz-form-item>
      <nz-form-label [nzSpan]="5">Plans and Addons</nz-form-label>
      <nz-form-control [nzSpan]="12">
        <nz-tree name="input-tree-sample" [nzData]="nodes" nzCheckable="true" nzMultiple="true"
          [nzCheckedKeys]="defaultCheckedKeys" [nzExpandedKeys]="defaultExpandedKeys"
          [nzSelectedKeys]="defaultSelectedKeys" (nzClick)="nzEvent($event)" (nzExpandChange)="nzEvent($event)"
          (nzCheckBoxChange)="nzEvent($event)">
        </nz-tree>
      </nz-form-control>
    </nz-form-item>


  </div>

  <div id="form-layouts">
    <h1 class="kitchensink">Form Layouts</h1>

    <h1>Auto - One </h1>
    <div class="flexie-auto-grid">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <h1>Auto - Two </h1>
    <div class="flexie-auto-grid">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <h1>Auto - Four </h1>
    <div class="flexie-auto-grid">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <h1>Auto - Three (Match grid) </h1>
    <div class="flexie-auto-grid">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <!-- Leave this empty for 3 cols, match-grid -->
      </nz-form-item>

    </div>

    <h1> Auto - Three </h1>
    <div class="flexie-auto-grid">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">Great Label</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Basic usage" [(ngModel)]="value" name="input-basic" />
        </nz-form-control>
      </nz-form-item>
    </div>

  </div>

  <div id="samples">
    <h1 class="kitchensink">Samples</h1>

    <div class="flexie-auto-grid">

      <div>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Select</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group nzName="radiogroup" [nzButtonStyle]="'solid'" [(ngModel)]="radioValue" name="radiogroup">
              <label nz-radio-button nzValue="A">Search Agent</label>
              <label nz-radio-button nzValue="B">Add new Agent</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div>
        <button nz-button [nzType]="'primary'" (click)="toggleCollapsed()" style="margin-bottom: 10px;">
          <i nz-icon [nzType]="isCollapsed?'menu-unfold':'menu-fold'"></i>
        </button>
        <ul nz-menu [nzMode]="'inline'" nzTheme='dark' [nzInlineCollapsed]="isCollapsed">
          <!-- <li nz-menu-item nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="isCollapsed ? 'Navigation One' : ''">
            <span title>
              <i nz-icon nzType="mail"></i>
              <span>Navigation One</span>
            </span>
          </li> -->
          <li nz-submenu>
            <span title>
              <i nz-icon nzType="appstore"></i>
              <span>Navigation Two</span>
            </span>
            <ul>
              <li nz-menu-item>Option 5</li>
              <li nz-menu-item>Option 6</li>
              <li nz-submenu>
                <span title>Submenu</span>
                <ul>
                  <li nz-submenu>
                    <span title>Submenu</span>
                    <ul>
                      <li nz-submenu>
                        <span title>Submenu</span>
                        <ul>
                          <li nz-menu-item>Option 7</li>
                          <li nz-menu-item>Option 8</li>
                        </ul>
                      </li>
                      <li nz-menu-item>Option 8</li>
                    </ul>
                  </li>
                  <li nz-menu-item>Option 8</li>
                </ul>
              </li>
            </ul>
          </li>
          <li nz-submenu>
            <span title>
              <i nz-icon nzType="setting"></i>
              <span>Navigation Three</span>
            </span>
            <ul>
              <li nz-menu-item>Option 9</li>
              <li nz-menu-item>Option 10</li>
              <li nz-menu-item>Option 11</li>
            </ul>
          </li>
        </ul>
      </div>

      <div>
        <nz-button-group>
          <button nz-button class="b-0"><i nz-icon nzType="left"></i>Backward</button>
          <nz-dropdown-menu class="b-0">
            DropDown
            <ul nz-menu>
              <li nz-menu-item>1st menu item</li>
              <li nz-menu-item>2nd menu item</li>
              <li nz-submenu>
                <span title>sub menu</span>
                <ul>
                  <li nz-menu-item>3rd menu item</li>
                  <li nz-menu-item>4th menu item</li>
                </ul>
              </li>
            </ul>
          </nz-dropdown-menu>
        </nz-button-group>

        <br><br>

        <button nz-button nzType="primary" (click)="showModalMiddle()">
          Search & Add Agents
        </button>

        <nz-modal nzWidth="90%" nzWrapClassName="flex-both-center" [(nzVisible)]="isVisibleMiddle"
          nzTitle="Vertically centered modal dialog" (nzOnCancel)="handleCancelMiddle()" (nzOnOk)="handleOkMiddle()">
          <nz-table #rowSelectionTable [nzData]="dataTable" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            (nzPageIndexChange)="refreshStatus()" (nzPageSizeChange)="refreshStatus()">
            <thead>
              <tr>
                <th nzShowCheckbox [(nzChecked)]="allChecked" [nzIndeterminate]="indeterminate"
                  (nzCheckedChange)="checkAll($event)"></th>
                <th>Name</th>
                <th>Age</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of rowSelectionTable.data">
                <td nzShowCheckbox [(nzChecked)]="data.checked" [nzDisabled]="data.disabled"
                  (nzCheckedChange)="refreshStatus()"></td>
                <td>{{data.name}}</td>
                <td>{{data.age}}</td>
                <td>{{data.address}}</td>
              </tr>
            </tbody>
          </nz-table>
        </nz-modal>

      </div>

      <div>
        <nz-collapse [nzAccordion]="true" [nzBordered]="false">
          <nz-collapse-panel [nzHeader]="'Panel X'" [nzActive]="false" [nzDisabled]="false">
            <p style="margin:0;">A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can
              be found as a welcome guest in many households across the world.</p>
          </nz-collapse-panel>
          <nz-collapse-panel [nzHeader]="'Panel Y'" [nzActive]="false" [nzDisabled]="false">
            <p style="margin:0;">A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can
              be found as a welcome guest in many households across the world.</p>
          </nz-collapse-panel>
          <nz-collapse-panel [nzHeader]="'Panel Z'" [nzActive]="false" [nzDisabled]="false">
            <p style="margin:0;">A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can
              be found as a welcome guest in many households across the world.</p>
          </nz-collapse-panel>
        </nz-collapse>

        <h2>Star Rating </h2>
        <nz-rate [(ngModel)]="ratingValue" name="rating-star" nzAllowHalf></nz-rate>
        <span *ngIf="ratingValue" class="ant-rate-text">{{ ratingValue }} stars</span>

      </div>


    </div>

  </div>

  <div id="loading">
    <h1 class="kitchensink">Loading States</h1>


    <div class="flexie-auto-grid">
      <div>
        <nz-form-label [nzSpan]="24">Card </nz-form-label>
        <nz-skeleton [nzAvatar]="true" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
      </div>
      <div>
        <nz-form-label [nzSpan]="24">Animated</nz-form-label>
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      </div>
    </div>


  </div>

  <div>
    <h1 class="kitchensink">Carousel</h1>
    <div class="flexie-auto-grid">
      <div>
        <nz-carousel [nzEffect]="'fade'" [nzAutoPlay]="true" [nzDots]="true" name="carousel" style="width:100%;">
          <div nz-carousel-content *ngFor="let index of carouselArray" name="carousel-content">
            <h3>{{index}}</h3>
          </div>
        </nz-carousel>
      </div>
      <div>
        <h2>222</h2>
      </div>
    </div>
  </div>

  <div id="collapsible">

    <nz-collapse>
      <nz-collapse-panel [nzHeader]="'Summary'" [nzActive]="false" [nzDisabled]="false" [nzShowArrow]="true">
        <div>
          This is
          <p>sss</p>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

  </div>

</form>
